import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'core-js'

window.addEventListener('DOMContentLoaded', (event) => {
  
  const grey_bg = document.querySelector('#grey_bg');
  const mh = document.querySelectorAll('.menu-item-has-children');

  if(mh){
    mh.forEach(el => {
      el.addEventListener('mouseenter', et => {
        grey_bg.classList.add('active')
      })

      el.addEventListener('mouseleave', et => {
        grey_bg.classList.remove('active')
      })
    })
  }

  var hamburger = document.querySelector(".hamburger");
  var mitem = document.querySelector('.right-header .menu')
  var homeheader = document.querySelector('.homeheader')
  // On click
  if (hamburger) {

    hamburger.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
      mitem.classList.toggle('active')
      homeheader.classList.toggle('active')
      
    });
  }

  var scrollpos = window.scrollY
var header = document.querySelector("header")
var header_height = header.offsetHeight
var headerlogo = document.querySelector('.hdlogo')
var isHome = document.querySelector('.home')


var add_class_on_scroll = () => {
  header.classList.add("fade-in")
  headerlogo.src = 'https://www.penzjegynyomda.hu/wp-content/uploads/2020/12/logo.svg'
}
var remove_class_on_scroll = () => {
  header.classList.remove("fade-in")
  headerlogo.src = 'https://www.penzjegynyomda.hu/wp-content/uploads/2020/12/logo2.svg'
}
  if(isHome){
    window.addEventListener('scroll', function() { 
      scrollpos = window.scrollY;
  
      if (scrollpos >= header_height) { add_class_on_scroll() }
      else { remove_class_on_scroll() }
    })
  }
 

});

/*
	var handlers = []; // Each handler should have an 'identifier' property which is a function returning a boolean indicating
					   // whether or not an element can be zoomed, and a 'handler' property which returns the URL of the zoomed
					   // image

			$(document).ready(function(){
				$('body').zoomTooltip([imageIdentifier], {});
      });
      element.getAttribute('data-image');
*/
$("document").ready(function() {


  
if ($('.zoomItem').length > 0) {
  $(document).mousemove(function (e) {
    $(".pointer").css({ left: e.pageX, top: e.pageY });
  });
  
    $('.zoom').hover(function() {
      var what = $(this).data('image');
      $(".pointer img").attr('src', what);
    }, function() {
      $(".pointer img").attr('src', '');
    });
}

if ($('.gallery').length > 0) {

    $('a.gallery').featherlightGallery();

}

});